<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-07-13 09:17:17
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-02-10 08:32:08
-->

<template>
  <div class="SchoolProcurementRank">
    <div class="tab">第{{ current + 1 }}页</div>
    <div class="title">
      <img src="@/img/datav/title_icon.png" alt="" />
      <span>校园餐学校采购排行</span>
    </div>
    <swiper ref="Swiper" :options="swiperOption" class="swiper">
      <swiper-slide v-for="(data, i) in dataArray" :key="i">
        <vue-seamless-scroll
          v-if="current == i"
          :data="data"
          :class-option="getScrollOption(data.length)"
          class="progress-list"
          @ScrollEnd="handleScrollEnd"
        >
          <div
            v-for="(item, index) in data"
            :key="index"
            :class="['progress-item', 'item' + (pageSize * current + index + 1)]"
            :style="{ animationDelay: `${index * 0.05}s` }"
          >
            <div class="index">
              <svg class="school-outline" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
                <!-- 房子背景填充 -->
                <path
                  class="school-fill"
                  d="M30 5 L52 22 L52 52 L8 52 L8 22 Z"
                  fill="currentColor"
                  fill-opacity="0.15"
                />
                <!-- 房子轮廓：屋顶+墙体 -->
                <path
                  class="school-path"
                  d="M30 5 L52 22 L52 52 L8 52 L8 22 Z"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                />
                <!-- 屋顶线条 -->
                <path
                  class="roof-path"
                  d="M8 22 L30 5 L52 22"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                />
              </svg>
              <span class="index-num">{{ pageSize * current + index + 1 }}</span>
            </div>
            <div class="name">{{ item.gmCustomerName }}</div>
            <div class="price">
              <span class="amount">{{ item.purchaseAmount }}</span>
              <span class="unit">万元</span>
            </div>
          </div>
        </vue-seamless-scroll>
      </swiper-slide>
    </swiper>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import 'swiper/dist/js/swiper.esm.bundle.js'
import { customerPurchaseRank } from '@/api/dashboard'
import to from 'await-to'
const _ = require('lodash')
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        autoplay: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        onSlideChangeEnd: swiper => {
          this.current = swiper.activeIndex
        },
      },
      baseScrollOption: {
        step: 0.6,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 0,
      },
      type: 3,
      dataArray: [],
      current: 0,
      pageSize: 30,
    }
  },
  mounted() {
    this.initData()
    setInterval(() => {
      this.initData()
    }, process.env.VUE_APP_LTIME)
  },
  methods: {
    async initData() {
      const [res, err] = await to(
        customerPurchaseRank({
          type: this.type,
          size: 500,
        }),
      )
      if (err) return
      this.dataArray = _.chunk(res.data.list, this.pageSize)
    },
    typeChange(type) {
      this.type = type
      this.initData()
    },
    getScrollOption(dataLength) {
      return {
        ...this.baseScrollOption,
        limitMoveNum: dataLength,
      }
    },
    handleScrollEnd() {
      setTimeout(() => {
        if (this.current >= this.dataArray.length - 1) {
          this.$refs.Swiper.swiper.slideTo(0)
        } else {
          this.$refs.Swiper.swiper.slideNext()
        }
      }, 1000)
    },
  },
}
</script>
<style lang="scss" scoped>
.SchoolProcurementRank {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 20px 5px;

  .title {
    width: 550px;
    position: relative;
    font-size: 26px;
    color: #ecf8ff;
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    img {
      margin-right: 8px;
      animation: pulse 2s ease-in-out infinite;
    }
  }

  .tab {
    z-index: 99;
    position: absolute;
    right: 60px;
    top: 30px;
    width: 126px;
    font-size: 20px;
    text-align: center;
    animation: fadeIn 0.5s ease-out;
  }

  .swiper-button-next {
    z-index: 999;
    top: 55px;
    position: absolute;
    right: 40px;
    height: 22px;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.2);
    }
  }

  .swiper-button-prev {
    z-index: 999;
    top: 55px;
    position: absolute;
    left: 450px;
    height: 22px;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.2);
    }
  }

  .swiper {
    height: 740px;
  }

  .progress-list {
    box-sizing: border-box;
    padding-left: 8px;
    height: 720px;
    overflow: hidden;

    .progress-item {
      display: flex;
      align-items: center;
      margin-bottom: 17px;
      line-height: 35px;
      padding: 8px 15px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      cursor: pointer;
      will-change: transform;
      animation: slideInLeft 0.5s ease-out forwards;
      opacity: 0;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -9px;
        left: 15px;
        right: 15px;
        height: 1px;
        background: linear-gradient(
          90deg,
          rgba(102, 255, 255, 0.5) 0%,
          rgba(102, 255, 255, 0.1) 60%,
          transparent 100%
        );
      }

      &:hover {
        background: linear-gradient(
          90deg,
          rgba(102, 255, 255, 0.12) 0%,
          rgba(102, 255, 255, 0.04) 100%
        );
        transform: translateX(8px);
        box-shadow: -4px 0 20px rgba(102, 255, 255, 0.15);

        &::after {
          background: linear-gradient(
            90deg,
            rgba(102, 255, 255, 0.7) 0%,
            rgba(102, 255, 255, 0.2) 60%,
            transparent 100%
          );
        }
      }

      .index {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        position: relative;

        .school-outline {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          color: rgba(102, 255, 255, 0.8);
          filter: drop-shadow(0 0 4px rgba(102, 255, 255, 0.3));
          transition: all 0.3s ease;
        }

        .index-num {
          position: relative;
          z-index: 1;
          font-weight: bold;
          font-size: 18px;
          color: #ffffff;
          margin-top: 4px;
        }
      }

      &.item1,
      &.item2,
      &.item3 {
        .index {
          .index-num {
            font-weight: bold;
          }
        }
      }

      &.item1 {
        .index {
          .school-outline {
            color: rgba(255, 215, 0, 0.9);
            filter: drop-shadow(0 0 6px rgba(255, 215, 0, 0.5));

            .school-fill {
              fill: rgba(255, 215, 0, 0.9);
              fill-opacity: 0.25;
            }
          }
        }
      }

      &.item2 {
        .index {
          .school-outline {
            color: rgba(192, 192, 192, 0.9);
            filter: drop-shadow(0 0 6px rgba(192, 192, 192, 0.5));

            .school-fill {
              fill: rgba(192, 192, 192, 0.9);
              fill-opacity: 0.25;
            }
          }
        }
      }

      &.item3 {
        .index {
          .school-outline {
            color: rgba(205, 127, 50, 0.9);
            filter: drop-shadow(0 0 6px rgba(205, 127, 50, 0.5));

            .school-fill {
              fill: rgba(205, 127, 50, 0.9);
              fill-opacity: 0.25;
            }
          }
        }
      }

      &.item4,
      &.item5,
      &.item6,
      &.item7,
      &.item8,
      &.item9,
      &.item10 {
        .index {
          .school-outline {
            color: rgba(0, 200, 255, 0.8);
            filter: drop-shadow(0 0 4px rgba(0, 200, 255, 0.3));
          }
        }
      }

      .name {
        font-weight: 500;
        font-size: 24px;
        color: #ffffff;
        margin-right: 21px;
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        transition: all 0.3s ease;
      }

      &:hover .name {
        color: #66ffff;
        text-shadow: 0 0 10px rgba(102, 255, 255, 0.5);
      }

      .price {
        display: flex;
        align-items: baseline;
        color: #66ffff;
        text-shadow: 0 0 6px rgba(102, 255, 255, 0.3);
        transition: all 0.3s ease;

        .amount {
          font-size: 24px;
          font-weight: 700;
        }

        .unit {
          font-size: 14px;
          font-weight: 400;
          margin-left: 4px;
          opacity: 0.8;
        }
      }

      &:hover .price {
        text-shadow: 0 0 15px rgba(102, 255, 255, 0.6);

        .amount {
          transform: scale(1.1);
        }
      }
    }
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes glow {
  from {
    box-shadow: 0 0 12px currentColor;
  }
  to {
    box-shadow: 0 0 20px currentColor, 0 0 30px currentColor;
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
